<template>
  <div class="use-new">
    <b-row>
      <b-col cols="12 mt-50">
        <b-list-group class="list-group-circle mt-2 ">
          <b-list-group-item v-for="item in listNews" :key="item.id" :title="item.contents"
                             class="list-group-item text-body" v-bind:class="{ 'active': isSelected(item.id) }"
                             v-on:click="detailClick(item)">
            <span :style="[ item.isRead ? {opacity: 0.5}: {opacity: 1}]"> {{ item.name }} </span>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
    <!-- chính sách  -->
    <b-modal id="modal-view" :title="getTitle()" scrollable size="xl" @ok="handleOk">
      <b-row class="use-new">
        <b-col class="view-left mt-50" cols="4">
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Ngày hiệu lực: </label>
                <label class="ml-50"> {{ currentItem.effect_date }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Phòng ban chủ trì: </label>
                <label class="ml-50"> {{ currentItem.department_presiding_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Phòng ban tham gia: </label>
                <label class="ml-50"> {{ currentItem.department_join_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="currentItem.cate_type_new == 0 || currentItem.cate_type_new == 1">
            <b-col cols="12">
              <b-form-group>
                <label>Người soạn thảo: </label>
                <label class="ml-50"> {{ currentItem.creator_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="currentItem.cate_type_new == 0 || currentItem.cate_type_new == 1">
            <b-col cols="12">
              <b-form-group>
                <label>Người phê duyệt: </label>
                <label class="ml-50"> {{ currentItem.approver }}</label>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="mt-50 border-left" cols="8">
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Đối tượng áp dụng: </label>
                <label class="ml-50"> {{ currentItem.applicable_object }}</label>
              </b-form-group>
            </b-col>

            <b-col v-if="currentItem.cat_type_new == 1" cols="12">
              <b-form-group>
                <label>Trường hợp áp dụng: </label>
                <label class="ml-50"> {{ currentItem.applicable_cases }}</label>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <!-- eslint-disable vue/no-v-html -->
                <div class="question-content" v-html="currentItem.contents"/>
                <!-- eslint-enable -->
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group>
                <b-input-group v-if="currentItem && currentItem.file_path" class="input-group-merge"
                               @click="downloadFile(currentItem.file_path)">
                  <div class="sample-file__download">
                    <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
                  </div>
                  {{ currentItem.file_path }}
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <!-- kt chính sách + quy trình -->
    <!-- khuyến mại -->
    <b-modal id="modal-view-promotion" :title="getTitle()" scrollable size="xl" @ok="handleOk">
      <b-row class="use-new">
        <b-col class="view-left mt-50" cols="4">
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Ngày hiệu lực: </label>
                <label class="ml-50"> {{ currentItem.effect_date }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Phòng ban chủ trì: </label>
                <label class="ml-50"> {{ currentItem.department_presiding_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Phòng ban tham gia: </label>
                <label class="ml-50"> {{ currentItem.department_join_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="mt-50 border-left" cols="8">
          <b-row>
            <b-col cols="6">
              <b-form-group>
                <label>Ngày bắt đầu: </label>
                <label class="ml-50"> {{ currentItem.from_date }}</label>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <label>Ngày kết thúc: </label>
                <label class="ml-50"> {{ currentItem.to_date }}</label>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <label>Đối tượng áp dụng: </label>
                <label class="ml-50"> {{ currentItem.applicable_object }}</label>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <label>Phạm vi áp dụng: </label>
                <label class="ml-50"> {{ currentItem.application_scope }}</label>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label>Hình thức triển khai: </label>
                <label class="ml-50"> {{ currentItem.deployment_form }}</label>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <!-- eslint-disable vue/no-v-html -->
                <div class="question-content" v-html="currentItem.contents"/>
                <!-- eslint-enable -->
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group>
                <b-input-group v-if="currentItem && currentItem.file_path" class="input-group-merge"
                               @click="downloadFile(currentItem.file_path)">
                  <div class="sample-file__download">
                    <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
                  </div>
                  {{ currentItem.file_path }}
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <!-- kt khuyến mại -->
    <!-- Hướng dẫn sử dụng -->
    <b-modal id="modal-view-help" :title="getTitle()" scrollable size="xl" @ok="handleOk">
      <b-row class="mt-50 ">
        <b-col cols="12">
          <b-form-group>
            <label>Mục đích: </label>
            <label class="ml-50"> {{ currentItem.purposes }}</label>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <label>Đối tượng áp dụng: </label>
            <label class="ml-50"> {{ currentItem.applicable_object }}</label>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <!-- eslint-disable vue/no-v-html -->
            <div class="question-content" v-html="currentItem.contents"/>
            <!-- eslint-enable -->
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group>
            <b-input-group v-if="currentItem && currentItem.file_path" class="input-group-merge"
                           @click="downloadFile(currentItem.file_path)">
              <div class="sample-file__download">
                <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
              </div>
              {{ currentItem.file_path }}
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-left">
        <b-button class="btn-sm mr-50 ml-50" variant="primary" @click="showFeedback(currentItem)">
          <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
          Gửi đề xuất góp ý
        </b-button>
      </b-row>
    </b-modal>
    <!-- Hướng dẫn sử dụng -->
    <!-- Gửi nội dung feedback -->
    <b-modal id="modal-feedback" scrollable size="xl" title="Gửi ý kiến phản hồi" @ok="handleFeedbackOk">
      <b-row class="mt-50">
        <b-col cols="12">
          <b-form-group>
            <label>Thuộc: </label>
            <label class="ml-50"> {{ feedbackItem.newName }}</label>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-textarea id="textarea-auto-height" v-model="feedbackItem.contents" max-rows="8"
                           placeholder="Nhập đề xuất của bạn" rows="8"/>
        </b-col>
        <b-col class="mt-50 text-left" cols="12">
          <b-form-group>

            <div v-if="feedbackItem && feedbackItem.file_path">
              <div class="sample-file__download">
                <feather-icon icon="UploadIcon" style="margin-right: 8px;"/>
              </div>
              {{ feedbackItem.file_path }}
            </div>
            <b-form-file v-model="feedbackItem.file" accept="application/pdf,application/vnd.ms-excel,application/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document" plain
                         v-on:input="uploadFile">
            </b-form-file>
          </b-form-group>
        </b-col>

      </b-row>

    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BForm,
  BInputGroup,
  BFormInput,
  BCardText,
  BInputGroupPrepend,
  BListGroup,
  BListGroupItem,
  BFormGroup,
  VBTooltip,
  BFormFile,
  BButton,
  BFormTextarea
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import moment from "moment";
import {TypeCategories} from '@/@core/utils/utils';
import {getuserName} from '@/@core/utils/utils';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    BForm,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BListGroupItem,
    BListGroup,
    BFormGroup,
    VBTooltip,
    BFormFile,
    BButton,
    BFormTextarea
  },

  data() {
    return {
      searchQuery: "",
      listNews: [],
      currentItem: {},
      selected: 0,
      modal_title: "",
      feedbackItem: {},
      emalConfigs: []
    };
  },
  computed: {},
  created() {
    const topicId = this.$route.params.topicId;
    if (topicId && topicId > 0) {
      this.fetchData(this.$route.params.topicId);
    }
    this.loadEmailConfig();
  },
  watch: {
    $route(to, from) {
      let topicId = to.params.topicId ? to.params.topicId : 0;
      if (topicId > 0) {
        this.fetchData(topicId);
      }
    },
  },
  methods: {
    getTitle() {
      return this.modal_title;
    },
    quickSearch() {
      const topicId = this.$route.params.topicId;
      if (topicId && topicId > 0) {
        this.fetchData(this.$route.params.topicId);
      }
    },
    handleOk() {

    },
    fetchData(topicId) {
      useJwt
          .get("portal/newsgroupbytopicId?topicId=" + topicId + "&filter=" + this.searchQuery)
          .then((response) => {
            if (response.data.code == 200) {
              this.listNews = response.data.result;
              // this.$toast({
              //   component: ToastificationContent,
              //   props: {
              //     title: "Lấy thông tin thành công",
              //     icon: "AlertTriangleIcon",
              //     variant: "success",
              //   },
              // });
            }
          })
          .catch((err) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.result,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },
    detailClick(row) {
      const id = row.id;
      this.loading(true);
      useJwt
          .get("portal/getnewsgroupById?id=" + id)
          .then((response) => {
            if (response.data.code == 200) {
              row.isRead = true;
              this.currentItem = response.data.result[0];
              this.currentItem.effect_date = this.formatDate(this.currentItem.effect_date);
              if (this.currentItem.from_date) {
                this.currentItem.from_date = this.formatDate(this.currentItem.from_date);
              }
              if (this.currentItem.to_date) {
                this.currentItem.to_date = this.formatDate(this.currentItem.to_date);
              }
              this.modal_title = this.currentItem.name;
              if (this.currentItem.cat_type_new == TypeCategories.POLICY || this.currentItem.cat_type_new == TypeCategories.PROCESS_REGULATIONS) {
                this.$bvModal.show("modal-view");
              } else if (this.currentItem.cat_type_new == TypeCategories.PROMOTION) {
                this.$bvModal.show("modal-view-promotion");
              } else if (this.currentItem.cat_type_new == TypeCategories.HELP) {
                this.$bvModal.show("modal-view-help");
              }
            }

            this.loading(false);
          })
          .catch((err) => {
            this.loading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.result,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },
    isSelected: function (i) {
      return i === this.selected
    },
    dateFormat(v) {
      return moment(v, 'YYYYMMDDHHmmss').format('DD/MM/YYYY hh:mm:ss')
    },
    formatDate(v) {
      return moment(v, 'YYYY/MM/DD').format('DD/MM/YYYY')
    },

    async loadEmailConfig() {
      this.loading(true);
      useJwt.get("portal/emailconfig").then((response) => {
        var result = response.data;
        if (result.code == 200) {

          result.result.forEach(item => {
            this.emalConfigs.push(item.email);
          });
        }

        this.isLoading = false;
        this.loading(false);
      });
    },

    showFeedback(itemNew) {
      this.feedbackItem = {};
      this.feedbackItem.new_group_id = itemNew.id;
      this.feedbackItem.newName = itemNew.name;
      this.$bvModal.show("modal-feedback");
    },

    async handleFeedbackOk(bvModalEv) {
      bvModalEv.preventDefault();
      const userName = getuserName();
      if (!this.feedbackItem.contents || this.feedbackItem.contents.trim().length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải nhập nội dung góp ý!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return false;
      }
      try {
        const createParams = {
          id: 0,
          new_group_id: this.feedbackItem.new_group_id,
          contents: this.feedbackItem.contents,
          notes: this.feedbackItem.notes,
          created_at: userName,
          emails: this.emalConfigs.join(','),
          newName: this.feedbackItem.newName,
          type: 0
        };
        this.loading(true);
        const res = await useJwt.post("portal/feedback", createParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.$bvModal.hide("modal-feedback");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới ý kiến phản hồi!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới ý kiến phản hồi ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    async uploadFile() {
      var formData = new FormData();
      formData.append("file", this.feedbackItem.file);
      this.loading(true);
      const res = await useJwt.post(`portal/upload`, formData);
      this.loading(false);
      if (res.data.code == 200) {
        this.feedbackItem.file_path = res.data.result;
      }
    },
    async downloadFile(filePath) {
      try {
        const downloadParams = {filePath: filePath};
        const arrFile = filePath.replaceAll('\\', '/').split('/');
        this.loading(true);
        const res = await useJwt.postDownload("portal/download", arrFile[1], downloadParams);
        this.loading(false);
        // if (res.status != 200) {
        //   this.$toast({
        //     component: ToastificationContent,
        //     props: {
        //       title: "File không đúng hoặc không còn tồn tại.",
        //       icon: "AlertTriangleIcon",
        //       variant: "danger"
        //     },
        //   });
        // }
      } catch (err) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "File không đúng hoặc không còn tồn tại.",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
      }
    }
  },
};

</script>
<style lang="css">
.list-group-item:focus,
list-group-item:hover,
button.list-group-item:focus,
button.list-group-item:hover {
  color: #555;
  text-decoration: none;
  background-color: #dfdfdf !important;
  cursor: pointer;
}

.list-group-item.active,
.list-group-item.active:focus,
.list-group-item.active:hover {
  z-index: 2;
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
  cursor: pointer;
}

.list-group-item > span {
  cursor: pointer;
}

.modal .modal-header {
  background-color: #ed1f24;
  color: black !important;
}

.modal-header h5 {
  color: black !important;
}

.use-new label {
  line-height: 50px;
  font-size: 1rem;
  min-width: 100px;
}

.border-left {
  border-left: 2px solid #ccc;
}

.list-group.list-group-circle .list-group-item:hover,
.list-group .list-group-item:hover {
  background-color: rgb(34 41 47 / 10%) !important;
}

.question-content {
  min-height: 330px;
}

.input-group-merge {
  cursor: pointer;
}

</style>
<style lang="scss">
@import "@core/scss/vue/pages/page-knowledge-base.scss";
@import "@core/scss/vue/bootstrap-vue/tooltip";
</style>
